import React, { useEffect } from "react";
import Header from "./components/Header";
import HomeOffline from "./pages/HomeOffline";
import Footer from "./components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import { BrowserRouter, Route, Routes, Outlet } from "react-router-dom";
import ConceptForm from "./pages/ConceptForm";
import Register from "./pages/Register";
import VerifyEmail from "./pages/verifyEmail/VerifyEmail";
import { useAuthContext } from "./hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "./constants/ApiConntection";
import HomeOnline from "./pages/homeOnline/HomeOnline";
import CreateWebsite from "./pages/createWebsite/CreatWebsite";
import MyOneWebsite from "./pages/myOneWebsite/MyOneWebsite";
import MyAccount from "./pages/myAccount/MyAccount";
import InitialPasswordSetup from "./pages/initialPasswordSetup/InitialPasswordSetup";
import Pricing from "./pages/Pricing";
import Faq from "./pages/faq/FAQ";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import UserAgreement from "./pages/UserAgreement";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import PaymentSuccess from "./pages/paymentSuccess/PaymentSuccess";
import PaymentCancel from "./pages/paymentCancel/PaymentCancel";
import CounsellingConcept from "./concept/CounsellingConcept";
import CounsellingConceptTwo from "./concept/CounsellingConceptTwo";
import CounsellingConceptThree from "./concept/CounsellingConceptThree";
import CounsellorSiteBriefFormTwo from "./form/CounsellorSiteBriefFormTwo";

function App() {
  const { user, dispatch } = useAuthContext();

  useEffect(() => {
    const existingUser = JSON.parse(localStorage.getItem("user"));
    const getUser = async () => {
      try {
        await axios.get(`${ApiConnectionString}/api/user/checkstatus/`, {
          headers: { Authorization: `bearer ${existingUser.token}` },
        });
        dispatch({ type: "WELCOMEBACK", payload: existingUser });
      } catch (error) {
        if (error.response && error.response.status === 401) {
          dispatch({ type: "LOGOUT", payload: {} });
        }
      }
    };
    if (existingUser) getUser();
  }, [dispatch]);

  const LayoutWithHeaderFooter = () => (
    <>
      <div className="app-body">
        <Header />
        <Outlet />
        <Footer />
      </div>
    </>
  );

  return (
    <BrowserRouter>
      <Routes>
        {/* Routes WITH Header + Footer */}

        <Route element={<LayoutWithHeaderFooter />}>
          <Route path="/" element={!user ? <HomeOffline /> : <HomeOnline />} />
          <Route path="/signup" element={<Register />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/agreement" element={<UserAgreement />} />

          <Route path="/createWebsite" element={<CreateWebsite />} />
          <Route path="/myOneWebsite/:id" element={<MyOneWebsite />} />
          <Route path="/myaccount" element={<MyAccount />} />
        </Route>

        {/* Standalone routes WITHOUT Header + Footer */}
        <Route path="/concept" element={<ConceptForm />} />
        <Route path="/verifyEmail/:token" element={<VerifyEmail />} />
        <Route
          path="/initialPasswordSetup/:token"
          element={<InitialPasswordSetup />}
        />
        <Route path="/resetPassword/:token" element={<ResetPassword />} />
        <Route path="/success" element={<PaymentSuccess />} />
        <Route path="/cancel" element={<PaymentCancel />} />
        <Route
          path="/counselling-concept/:id"
          element={<CounsellingConcept />}
        />
        <Route
          path="/counselling-concept-two/:id"
          element={<CounsellingConceptTwo />}
        />
        <Route
          path="/counselling-concept-three/:id"
          element={<CounsellingConceptThree />}
        />
        <Route
          path="/Counselling-concept-form-two"
          element={<CounsellorSiteBriefFormTwo />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
